import { render, staticRenderFns } from "./PdfCreate4.vue?vue&type=template&id=3945ac2a&scoped=true"
import script from "./PdfCreate4.vue?vue&type=script&lang=js"
export * from "./PdfCreate4.vue?vue&type=script&lang=js"
import style0 from "./PdfCreate4.vue?vue&type=style&index=0&id=3945ac2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3945ac2a",
  null
  
)

export default component.exports